export function resolveCanvasSelectedVersion({
  selectedVersion,
  previousLastSuccessfulVersion,
  nextLastSuccessfulVersion,
}: {
  selectedVersion: number | null;
  previousLastSuccessfulVersion: number | null;
  nextLastSuccessfulVersion: number | null;
}): number | null {
  return !selectedVersion || selectedVersion === previousLastSuccessfulVersion
    ? nextLastSuccessfulVersion
    : selectedVersion;
}
